// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"f1be96a8","377":"c3b3828f","482":"f0687db8","568":"d29d5d3b","901":"c47183be"}[chunkId] + ".chunk.js";
};